export enum SitesLocalePrefix {
  SITES = 'sites',
  SITES_LIST = 'sites.list',
  SITE_SINGLE = 'sites.singleSite',
  SITE_TIMESLOT_SIDEBAR = 'sites.singleSite.sidebar',
  SITE_SALES = 'sites.singleSite.salesChannel',
  SITE_DEVICE_MAPPING = 'sites.singleSite.deviceMapping',
  SITE_REPORTING = 'sites.singleSite.reporting',
  SITE_OVERVIEW = 'sites.singleSite.overview',
  SITE_SCHEDULE = 'sites.schedule',
  SITE_STATION = 'sites.station',
  SITE_SCHEDULE_SIDE_PANEL = 'sites.schedule.sidePanel',
  SITE_DELETE_STATION = 'sites.singleSite.deleteStation',
  SITE_UPDATE_STATION = 'sites.singleSite.stationUpdate',
  SITE_DROP_OFF = 'sites.singleSite.dropoffLocations',
  SITE_KDS = 'sites.singleSite.kds',
  SITE_FINANCIAL_CONFIG = 'sites.singleSite.financialConfig',
  SITE_PAYMENT_INFO = 'sites.singleSite.financialConfig.paymentInfo',
  SITE_CASHLESS_PAYMENT = 'sites.singleSite.financialConfig.cashlessPay',
  SITE_MEAL_PLAN = 'sites.singleSite.financialConfig.mealPlans',
  CRUD_DROP_OFF_LOCATION = 'sites.singleSite.dropoffLocations.locationSidebar',
  SITE_BUSINESS_UNIT = 'sites.businessUnit',
  STATION_INTEGRATIONS = 'sites.stationIntegrations',
  STATION_APP_CONFIG = 'sites.stationAppConfig',
  STATION_APP_CONFIG_PREORDER_FORM = 'sites.stationAppConfig.preOrder.form',
  STATION_APP_CONFIG_DROPOFF_LOCATIONS = 'sites.stationAppConfig.preOrder.form.dropoff.locations',
  STATION_APP_CONFIG_DROPOFF_CUSTOM = 'sites.stationAppConfig.preOrder.form.dropoff.custom',
  STATION_APP_CONFIG_PAYMENT_EXCLUSIONS = 'sites.stationAppConfig.paymentExclusions',
  SITE_SETTINGS = 'sites.siteSettings',
  SITE_ADDRESS_LOOKUP = 'sites.addressLookup',
  SITE_CENTRIC_POS = 'sites.singleSite.centricPos',
}
